import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=304b1af9&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=js&"
export * from "./Column.vue?vue&type=script&lang=js&"
import style0 from "./Column.vue?vue&type=style&index=0&id=304b1af9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304b1af9",
  null
  
)

export default component.exports